import React from "react";
import Display from "./Display";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import FetchApiProvider from "./api/FetchApiProvider";
import DataProvider from "./api/DataProvider";

const DisplayPage = () => {
    return (
        <FetchApiProvider>
            <DataProvider>
                <Display />
            </DataProvider>
        </FetchApiProvider>
    );
};

export default withAuthenticationRequired(DisplayPage);